module.exports = __webpack_public_path__ + "img/dev1.af7c83f3.png";